import styled from 'styled-components'
import { DisplaySmall, spacing, color } from '@conserveit/blocks'

export const Heading = styled(DisplaySmall)`
  color: ${color.theme.typography.ink};
  flex-basis: 100%;
`

export const DatagridWrapper = styled.div`
  flex-basis: 100%;
  padding: 0 ${spacing.default} ${spacing.default};
`
